import React from 'react';
import { AddressResultItemProps } from '@/experiences/sales-portal/components/address-search-input/types';
import { List } from '@usepepper/sprout-kit-ui';

const AddressResultItem: React.FC<AddressResultItemProps> = ({
  item,
  onSelect,
}) => {
  return (
    <List.Item onPress={() => onSelect(item)} pressable>
      <List.Item.Content>
        <List.Item.Title>{item.label}</List.Item.Title>
        <List.Item.Subtitle>{item.description}</List.Item.Subtitle>
      </List.Item.Content>
    </List.Item>
  );
};

export default AddressResultItem;
